export default __webpack_public_path__ + "static/smellsLikeVanilla-e4a35c5d00fbf1192ebe75db807319cf.png";